"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeTableColumns = void 0;
var react_1 = require("react");
var themes_1 = require("../../themes");
var utilsOolib_1 = require("../../utilsOolib");
var useResizeTableColumns = function (_a) {
    var setColWidthConfig = _a.setColWidthConfig, colWidthConfig = _a.colWidthConfig, theme = _a.theme, builderProps = _a.builderProps;
    var _b = (0, react_1.useState)(undefined), colResizeState = _b[0], setColResizeState = _b[1];
    var dragZoneWidth = 5;
    var handleResizeColumn = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (colResizeState) {
            setColWidthConfig(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[colResizeState.colId] = (colResizeState.initWidth + (e.clientX - colResizeState.mousePos)) + 'px', _a)));
            });
        }
    };
    var resetDragZoneIndicator = function (_a) {
        var e = _a.e, _b = _a.borderStyleInactive, borderStyleInactive = _b === void 0 ? "1px solid ".concat(themes_1.colors.greyColor10) : _b;
        if (colResizeState || e.currentTarget.id !== e.target.id)
            return;
        e.currentTarget.style.borderRight = borderStyleInactive;
        e.currentTarget.style.cursor = 'pointer';
    };
    var isInDragZone = function (e) {
        var mouseX = e.clientX;
        var colRightEdge = e.currentTarget.getBoundingClientRect().right;
        return mouseX > colRightEdge - dragZoneWidth;
    };
    var initColResizeState = function (e, d) {
        if (isInDragZone(e)) {
            e.preventDefault(); // these have to be inside isInDragZone, else clicking on cell wont allow rte to get focussed in SimpleTable
            e.stopPropagation();
            setColResizeState({
                mousePos: e.clientX,
                initWidth: parseInt(colWidthConfig[d.colId].replace('px', '')),
                colId: d.colId
            });
        }
    };
    var hideShowDragZoneIndicator = function (_a) {
        var e = _a.e, _b = _a.borderStyleActive, borderStyleActive = _b === void 0 ? "1px solid ".concat((0, utilsOolib_1.getPrimaryColor100)(theme === null || theme === void 0 ? void 0 : theme.colors)) : _b, _c = _a.borderStyleInactive, borderStyleInactive = _c === void 0 ? "1px solid ".concat(themes_1.colors.greyColor10) : _c;
        e.preventDefault();
        /** currentTarget is the element that this event is bound to */
        if (e.currentTarget.id !== e.target.id)
            return; //very important, else the indicator shows in some cases, when its not supposed to. we don't completely understand why...
        if (!colResizeState) {
            if (isInDragZone(e)) {
                e.currentTarget.style.borderRight = borderStyleActive;
                e.currentTarget.style.setProperty('cursor', 'col-resize', 'important'); // using the setProperty approach only so that we can apply !important
            }
            else {
                e.currentTarget.style.borderRight = borderStyleInactive;
                e.currentTarget.style.cursor = 'pointer';
            }
        }
    };
    var resetColResizeState = function (e) {
        setColResizeState(undefined);
        if (builderProps === null || builderProps === void 0 ? void 0 : builderProps.updateColWidthsInTableConfig) {
            builderProps.updateColWidthsInTableConfig(colWidthConfig);
        }
    };
    return ({
        resetColResizeState: resetColResizeState,
        hideShowDragZoneIndicator: hideShowDragZoneIndicator,
        initColResizeState: initColResizeState,
        resetDragZoneIndicator: resetDragZoneIndicator,
        handleResizeColumn: handleResizeColumn,
        colResizeState: colResizeState,
        dragZoneWidth: dragZoneWidth
    });
};
exports.useResizeTableColumns = useResizeTableColumns;
